import React from 'react';

import logo from '../../assets/interhyp-logo.png';

export function Logo(): JSX.Element {
  return <img height={35} className="logo" alt="interhyp" src={logo} />;
}
